
import { alertActions } from "../../alert.action";
import { languageService } from "../../../../services/system/language/language.service";
import { languageConstants } from "../../../../constants/system/language/language.constants";

export const languageActions = {
  getAllCodes,
  getAllCodesByEvent
};

function getAllCodes() {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    languageService.getAllCodes().then(
      languageCodes => {
        dispatch(success(languageCodes));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: languageConstants.GETALL_CODES_REQUEST };
  }
  function success(languageCodes) {
    return { type: languageConstants.GETALL_CODES_SUCCESS, languageCodes };
  }
  function failure(error) {
    return { type: languageConstants.GETALL_CODES_FAILURE, error };
  }
}

function getAllCodesByEvent(eventId) {
    return dispatch => {
      dispatch(request());
      dispatch(alertActions.clear());
      languageService.getAllCodesByEvent(eventId).then(
        languageCodes => {
          dispatch(success(languageCodes));
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
    };
  
    function request() {
      return { type: languageConstants.GETALL_CODES_BY_EVENT_REQUEST };
    }
    function success(languageCodes) {
      return { type: languageConstants.GETALL_CODES_BY_EVENT_SUCCESS, languageCodes };
    }
    function failure(error) {
      return { type: languageConstants.GETALL_CODES_BY_EVENT_FAILURE, error };
    }
  }
